// extracted by mini-css-extract-plugin
module.exports = {"products":"Products_products__gID6K"};